import Lenis from "lenis";
import EventEmitter from "../Utils/EventEmitter.js";

export default class Scroll extends EventEmitter {
  constructor() {
    super();
    this.lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    this.scrollPercent = 0;
    this.lenis.on("scroll", (e) => {
      this.scrollPercent = e.progress * 100;

      this.trigger("scroll", [e]);
    });
  }
  update(time) {
    this.lenis.raf(time);
  }
  start() {
    this.lenis.start();
  }
  stop() {
    this.lenis.stop();
  }

  scalePercent(start, end) {
    // On normalise la valeur (de 0-100 à 0-1) pour l'interpolation.
    const t = this.scrollPercent / 100;
    return start + t * (end - start);
  }
}
